// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AndoverMnRouteImport } from './routes/andover-mn'
import { Route as ContactUsThankYouRouteImport } from './routes/contact-us-thank-you'
import { Route as CoonRapidsMnRouteImport } from './routes/coon-rapids-mn'
import { Route as EastBethelMnRouteImport } from './routes/east-bethel-mn'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as GetFreeEstimateThankYouRouteImport } from './routes/get-free-estimate-thank-you'
import { Route as GutterInstallationRouteImport } from './routes/gutter-installation'
import { Route as GutterRepairRouteImport } from './routes/gutter-repair'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as RoofingInstallationRouteImport } from './routes/roofing-installation'
import { Route as RoofingRepairsRouteImport } from './routes/roofing-repairs'
import { Route as SidingInstallationRouteImport } from './routes/siding-installation'
import { Route as SidingRepairRouteImport } from './routes/siding-repair'
import { Route as StFrancisMnRouteImport } from './routes/st-francis-mn'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteCareersRouteImport } from './routes/_site/careers'
import { Route as SiteContactRouteImport } from './routes/_site/contact'
import { Route as SiteGuttersRouteImport } from './routes/_site/gutters'
import { Route as SiteIceStormsRouteImport } from './routes/_site/ice-storms'
import { Route as SiteMaintenanceChecklistRouteImport } from './routes/_site/maintenance-checklist'
import { Route as SiteRoofingRouteImport } from './routes/_site/roofing'
import { Route as SiteScheduleRouteImport } from './routes/_site/schedule'
import { Route as SiteSidingRouteImport } from './routes/_site/siding'
import { Route as SiteStormDamageRouteImport } from './routes/_site/storm-damage'
import { Route as SiteTestimonialsRouteImport } from './routes/_site/testimonials'
import { Route as BlogWhyWinterIsTheWorstTimeToIgnoreDamagedSidingAndWhatToDoAboutItRouteImport } from './routes/blog/why-winter-is-the-worst-time-to-ignore-damaged-siding-and-what-to-do-about-it'
import { Route as SiteBlogIndexRouteImport } from './routes/_site/blog/index'
import { Route as SiteBlogSlugRouteImport } from './routes/_site/blog/$slug'
import { Route as SiteProjectsIndexRouteImport } from './routes/_site/projects/index'
import { Route as SiteProjectsSlugRouteImport } from './routes/_site/projects/$slug'
import { Route as SiteServiceAreasIndexRouteImport } from './routes/_site/service-areas/index'
import { Route as SiteServiceAreasSlugRouteImport } from './routes/_site/service-areas/$slug'
import { Route as SiteServicesDeckInstallationRouteImport } from './routes/_site/services/deck-installation'
import { Route as SiteServicesGutterInstallationRouteImport } from './routes/_site/services/gutter-installation'
import { Route as SiteServicesGutterRepairsRouteImport } from './routes/_site/services/gutter-repairs'
import { Route as SiteServicesRoofRepairRouteImport } from './routes/_site/services/roof-repair'
import { Route as SiteServicesRoofReplacementRouteImport } from './routes/_site/services/roof-replacement'
import { Route as SiteServicesSidingRepairRouteImport } from './routes/_site/services/siding-repair'
import { Route as SiteServicesSidingReplacementRouteImport } from './routes/_site/services/siding-replacement'

const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AndoverMnRoute = AndoverMnRouteImport.update({
            id: '/andover-mn',path: '/andover-mn',getParentRoute: () => rootRouteImport
          })
const ContactUsThankYouRoute = ContactUsThankYouRouteImport.update({
            id: '/contact-us-thank-you',path: '/contact-us-thank-you',getParentRoute: () => rootRouteImport
          })
const CoonRapidsMnRoute = CoonRapidsMnRouteImport.update({
            id: '/coon-rapids-mn',path: '/coon-rapids-mn',getParentRoute: () => rootRouteImport
          })
const EastBethelMnRoute = EastBethelMnRouteImport.update({
            id: '/east-bethel-mn',path: '/east-bethel-mn',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const GetFreeEstimateThankYouRoute = GetFreeEstimateThankYouRouteImport.update({
            id: '/get-free-estimate-thank-you',path: '/get-free-estimate-thank-you',getParentRoute: () => rootRouteImport
          })
const GutterInstallationRoute = GutterInstallationRouteImport.update({
            id: '/gutter-installation',path: '/gutter-installation',getParentRoute: () => rootRouteImport
          })
const GutterRepairRoute = GutterRepairRouteImport.update({
            id: '/gutter-repair',path: '/gutter-repair',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const RoofingInstallationRoute = RoofingInstallationRouteImport.update({
            id: '/roofing-installation',path: '/roofing-installation',getParentRoute: () => rootRouteImport
          })
const RoofingRepairsRoute = RoofingRepairsRouteImport.update({
            id: '/roofing-repairs',path: '/roofing-repairs',getParentRoute: () => rootRouteImport
          })
const SidingInstallationRoute = SidingInstallationRouteImport.update({
            id: '/siding-installation',path: '/siding-installation',getParentRoute: () => rootRouteImport
          })
const SidingRepairRoute = SidingRepairRouteImport.update({
            id: '/siding-repair',path: '/siding-repair',getParentRoute: () => rootRouteImport
          })
const StFrancisMnRoute = StFrancisMnRouteImport.update({
            id: '/st-francis-mn',path: '/st-francis-mn',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteAboutRoute = SiteAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => SiteRoute
          })
const SiteCareersRoute = SiteCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => SiteRoute
          })
const SiteContactRoute = SiteContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => SiteRoute
          })
const SiteGuttersRoute = SiteGuttersRouteImport.update({
            id: '/gutters',path: '/gutters',getParentRoute: () => SiteRoute
          })
const SiteIceStormsRoute = SiteIceStormsRouteImport.update({
            id: '/ice-storms',path: '/ice-storms',getParentRoute: () => SiteRoute
          })
const SiteMaintenanceChecklistRoute = SiteMaintenanceChecklistRouteImport.update({
            id: '/maintenance-checklist',path: '/maintenance-checklist',getParentRoute: () => SiteRoute
          })
const SiteRoofingRoute = SiteRoofingRouteImport.update({
            id: '/roofing',path: '/roofing',getParentRoute: () => SiteRoute
          })
const SiteScheduleRoute = SiteScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => SiteRoute
          })
const SiteSidingRoute = SiteSidingRouteImport.update({
            id: '/siding',path: '/siding',getParentRoute: () => SiteRoute
          })
const SiteStormDamageRoute = SiteStormDamageRouteImport.update({
            id: '/storm-damage',path: '/storm-damage',getParentRoute: () => SiteRoute
          })
const SiteTestimonialsRoute = SiteTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => SiteRoute
          })
const BlogWhyWinterIsTheWorstTimeToIgnoreDamagedSidingAndWhatToDoAboutItRoute = BlogWhyWinterIsTheWorstTimeToIgnoreDamagedSidingAndWhatToDoAboutItRouteImport.update({
            id: '/blog/why-winter-is-the-worst-time-to-ignore-damaged-siding-and-what-to-do-about-it',path: '/blog/why-winter-is-the-worst-time-to-ignore-damaged-siding-and-what-to-do-about-it',getParentRoute: () => rootRouteImport
          })
const SiteBlogIndexRoute = SiteBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => SiteRoute
          })
const SiteBlogSlugRoute = SiteBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => SiteRoute
          })
const SiteProjectsIndexRoute = SiteProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => SiteRoute
          })
const SiteProjectsSlugRoute = SiteProjectsSlugRouteImport.update({
            id: '/projects/$slug',path: '/projects/$slug',getParentRoute: () => SiteRoute
          })
const SiteServiceAreasIndexRoute = SiteServiceAreasIndexRouteImport.update({
            id: '/service-areas/',path: '/service-areas/',getParentRoute: () => SiteRoute
          })
const SiteServiceAreasSlugRoute = SiteServiceAreasSlugRouteImport.update({
            id: '/service-areas/$slug',path: '/service-areas/$slug',getParentRoute: () => SiteRoute
          })
const SiteServicesDeckInstallationRoute = SiteServicesDeckInstallationRouteImport.update({
            id: '/services/deck-installation',path: '/services/deck-installation',getParentRoute: () => SiteRoute
          })
const SiteServicesGutterInstallationRoute = SiteServicesGutterInstallationRouteImport.update({
            id: '/services/gutter-installation',path: '/services/gutter-installation',getParentRoute: () => SiteRoute
          })
const SiteServicesGutterRepairsRoute = SiteServicesGutterRepairsRouteImport.update({
            id: '/services/gutter-repairs',path: '/services/gutter-repairs',getParentRoute: () => SiteRoute
          })
const SiteServicesRoofRepairRoute = SiteServicesRoofRepairRouteImport.update({
            id: '/services/roof-repair',path: '/services/roof-repair',getParentRoute: () => SiteRoute
          })
const SiteServicesRoofReplacementRoute = SiteServicesRoofReplacementRouteImport.update({
            id: '/services/roof-replacement',path: '/services/roof-replacement',getParentRoute: () => SiteRoute
          })
const SiteServicesSidingRepairRoute = SiteServicesSidingRepairRouteImport.update({
            id: '/services/siding-repair',path: '/services/siding-repair',getParentRoute: () => SiteRoute
          })
const SiteServicesSidingReplacementRoute = SiteServicesSidingReplacementRouteImport.update({
            id: '/services/siding-replacement',path: '/services/siding-replacement',getParentRoute: () => SiteRoute
          })





const SiteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,SiteCareersRoute: SiteCareersRoute,SiteContactRoute: SiteContactRoute,SiteGuttersRoute: SiteGuttersRoute,SiteIceStormsRoute: SiteIceStormsRoute,SiteMaintenanceChecklistRoute: SiteMaintenanceChecklistRoute,SiteRoofingRoute: SiteRoofingRoute,SiteScheduleRoute: SiteScheduleRoute,SiteSidingRoute: SiteSidingRoute,SiteStormDamageRoute: SiteStormDamageRoute,SiteTestimonialsRoute: SiteTestimonialsRoute,SiteIndexRoute: SiteIndexRoute,SiteBlogSlugRoute: SiteBlogSlugRoute,SiteProjectsSlugRoute: SiteProjectsSlugRoute,SiteServiceAreasSlugRoute: SiteServiceAreasSlugRoute,SiteServicesDeckInstallationRoute: SiteServicesDeckInstallationRoute,SiteServicesGutterInstallationRoute: SiteServicesGutterInstallationRoute,SiteServicesGutterRepairsRoute: SiteServicesGutterRepairsRoute,SiteServicesRoofRepairRoute: SiteServicesRoofRepairRoute,SiteServicesRoofReplacementRoute: SiteServicesRoofReplacementRoute,SiteServicesSidingRepairRoute: SiteServicesSidingRepairRoute,SiteServicesSidingReplacementRoute: SiteServicesSidingReplacementRoute,SiteBlogIndexRoute: SiteBlogIndexRoute,SiteProjectsIndexRoute: SiteProjectsIndexRoute,SiteServiceAreasIndexRoute: SiteServiceAreasIndexRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren = {
  SiteRoute: SiteRouteWithChildren,AboutUsRoute: AboutUsRoute,AdminRoute: AdminRoute,AndoverMnRoute: AndoverMnRoute,ContactUsThankYouRoute: ContactUsThankYouRoute,CoonRapidsMnRoute: CoonRapidsMnRoute,EastBethelMnRoute: EastBethelMnRoute,GalleryRoute: GalleryRoute,GetFreeEstimateThankYouRoute: GetFreeEstimateThankYouRoute,GutterInstallationRoute: GutterInstallationRoute,GutterRepairRoute: GutterRepairRoute,ReviewsRoute: ReviewsRoute,RoofingInstallationRoute: RoofingInstallationRoute,RoofingRepairsRoute: RoofingRepairsRoute,SidingInstallationRoute: SidingInstallationRoute,SidingRepairRoute: SidingRepairRoute,StFrancisMnRoute: StFrancisMnRoute,BlogWhyWinterIsTheWorstTimeToIgnoreDamagedSidingAndWhatToDoAboutItRoute: BlogWhyWinterIsTheWorstTimeToIgnoreDamagedSidingAndWhatToDoAboutItRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)